import { ExportTypeBaseService } from '/@/modules/export/services/ExportTypeBaseService';
import Lang from '/@/modules/core/app/services/Lang';

export class NotifyCreditorsInstructionsExportService extends ExportTypeBaseService {
  getFilename(): string {
    return 'notify-creditors-instructions.pdf';
  }

  getSnackBarTitle(): string {
    return Lang.t('guidancestep.notify-creditors-exporting');
  }
}
export default new NotifyCreditorsInstructionsExportService();
